import { styled } from "@mui/system";

import { useIsFrontAssistDomain } from "../../lib/hooks/useDomain";

const digitalReceptionLogo = new URL(
  "../../assets/images/DigitalReceptionLogo.png",
  import.meta.url,
);
const frontAssistLogo = new URL(
  "../../assets/images/FrontAssistLogo.png",
  import.meta.url,
);

const MUILogoImage = styled("div")<{ imageUrl: URL | string }>(
  ({ imageUrl }) => ({
    backgroundImage: `url("${imageUrl}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "32rem",
    height: "18rem",
    marginBottom: "6rem",

    "@media screen and (orientation: landscape)": {
      marginBottom: "2rem",
      width: "20rem",
      height: "11.25rem",
    },
  }),
);

interface LogoImageProps {
  imageUrl?: string;
}
const LogoImage = ({ imageUrl }: LogoImageProps) => {
  const isFrontAssist = useIsFrontAssistDomain();

  const defaultLogo = isFrontAssist ? frontAssistLogo : digitalReceptionLogo;

  return <MUILogoImage imageUrl={imageUrl || defaultLogo} />;
};

export default LogoImage;
